import { Component } from 'react'
import MobileDetect from 'mobile-detect'

const md = new MobileDetect(window.navigator.userAgent)
let ClassName

if (!md.mobile()) {
	ClassName = 'desktop'
} else {
	ClassName = 'mobile'
}

class HtmlTagClassName extends Component {
	componentDidMount() {
		document.querySelector('html').setAttribute('class', `${ClassName} ${this.props.className}`)
	}

	render() {
		return null
	}
}

export default HtmlTagClassName


// WEBPACK FOOTER //
// ./src/common/components/html-tag-class-name/index.js